module.exports = {"530625001":"溪洛渡街道","530625002":"永兴街道","530625102":"桧溪镇","530625103":"黄华镇","530625104":"茂林镇","530625105":"大兴镇","530625106":"莲峰镇","530625107":"务基镇","530625108":"码口镇","530625201":"团结乡","530625202":"细沙乡","530625203":"青胜乡","530625205":"马楠苗族彝族乡","530625206":"水竹乡","530625207":"墨翰乡","530625208":"伍寨彝族苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530625.json
// module id = 2719
// module chunks = 0